import ConfirmacaoEmail from './confirmacaoEmail';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
setLoadingValue,
checkConfirmationHashAction
} from '../../store/confirmacaoEmail/actions';

const mapStateToProps = state => ({
  confirmacaoEmail: state.confirmacaoEmailReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    setLoadingValue,
    checkConfirmationHashAction
  }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmacaoEmail));
